import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=677ea25e&"
import script from "./HomeLayout.vue?vue&type=script&lang=js&"
export * from "./HomeLayout.vue?vue&type=script&lang=js&"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports